import { useState } from "react";
import { faqs } from "@/mocks/news";

const schema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <section id="faq" className="bg-background-200/60 border-y border-background-200">
        <div className="mx-auto max-w-4xl px-4 md:px-6 py-12 md:py-16">
          <div className="text-center mb-8">
            <p className="text-primary-600 text-xs font-semibold tracking-[0.25em] mb-2">FAQ · 常见问题</p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于直击现场，你可能想问</h2>
          </div>

          <div className="space-y-3">
            {faqs.map((f, i) => {
              const isOpen = openIdx === i;
              return (
                <div key={i} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                  <button
                    onClick={() => setOpenIdx(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className="flex items-center gap-3">
                      <span className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xs font-bold">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-heading font-bold text-[15px] text-foreground-950">{f.q}</span>
                    </span>
                    <i className={`ri-add-line text-xl text-foreground-400 transition-transform duration-300 ${isOpen ? "rotate-45 text-primary-600" : ""}`} />
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-in-out ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-4 md:px-5 pb-4 pl-16 text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}